import { authService } from '../../service/auth-service'
import { logger } from '../../util/logger'
import { Spinner } from '../util/spinner/spinner'
import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const VerifyEmailForm = (): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [displayError, setDisplayError] = useState(false)
  const { verifyEmailCode } = useParams<{ verifyEmailCode: string }>()

  // TODO add error handling, display error message if not successful

  const verifyEmail = useCallback(async () => {
    try {
      setIsLoading(true)
      await authService.verifyEmail({ code: verifyEmailCode })
      setIsSuccessful(true)
    } catch (err) {
      setDisplayError(true)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    verifyEmail().catch((err) => {
      logger.error(err)
    })
  }, [verifyEmail])

  const renderErrorMessage = (): React.ReactElement => {
    if (!displayError) return <></>
    return <h1>Something went wrong</h1>
  }

  const renderSuccessMessage = (): React.ReactElement => {
    if (!isSuccessful) return <></>
    return <h1>Email verification was successful.</h1>
  }

  const renderInitMessage = (): React.ReactElement => {
    if (isSuccessful || displayError) return <></>
    return (
      <>
        <h1>Verifying your email</h1>
        {isLoading && <Spinner />}
      </>
    )
  }

  return (
    <>
      {renderErrorMessage()}
      {renderSuccessMessage()}
      {renderInitMessage()}
    </>
  )
}
